import React from 'react';
import "./card1.css"
import { useNavigate } from "react-router-dom";

function Card2() {
    const navigate = useNavigate();
    return (
        <div className="card1 bg-danger text-white">
            <div className="card-body1">
                <div style={{ color: "#EE4358", display: "flex", alignItems: "center" }}>
                    {/* <bold style={{ fontWeight: "900" }}>Get in touch</bold> */}
                    <img src="./getIntouch.png" />
                </div>
                <div style={{ width: "1px", backgroundColor: "#CCCCCC" }}></div>
                <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                    <p className="card-text1" style={{ color: "black", textAlign: "left" }}>
                        <span style={{ color: "black", fontWeight: "800", fontSize: "16px" }}>
                            Your Trusted Paying Guest Accommodation Partner
                        </span>
                        <br />
                        Find comfortable, secure, and well-maintained paying guest accommodations that truly feel like home.
                        We help students and working professionals discover the right PG with essential amenities,
                        convenient locations, and a hassle-free living experience.
                    </p>
                    <button
                        onClick={() => navigate("/contactUs")}
                        className="btn btn-light btn-red-background btn-modal"
                    >
                        Book a PG Now
                    </button>
                </div>
            </div>
        </div>
    );
}

export default Card2;